import {
  Component, HostListener, OnInit, QueryList, ViewChildren
} from '@angular/core';
import { NgbdSortableHeader, SortEvent } from '../../../../../shared/directives/NgbdSortableHeader';
import { Observable, take } from 'rxjs';
import { EmpresasService } from '../../../../../shared/services/empresas.service';
import { Router } from '@angular/router';
import { Utils } from '../../../../../shared/utils/Utils';
const Swal = require("sweetalert2");
import * as data from '../../../../../shared/data/dashboard/social';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { forkJoin } from 'rxjs';
import { DataService } from '../../../../../shared/services/municipios.service';
import { AuthService } from '../../../../../shared/services/auth.service';

@Component({
  selector: 'app-empresas-activas',
  templateUrl: './empresas-activas.component.html',
  styleUrls: ['./empresas-activas.component.scss']
})
export class EmpresasActivasComponent implements OnInit {
  /*** Propiedades y estado del componente ***/
  public facebook = data.facebook;
  public selected = [];
  public searchText = ''; // Texto de búsqueda ingresado
  total$: Observable<number>;
  public show: boolean = false;

  // Variables para el manejo de dropdowns
  openDropdown: any = null;
  openDropdown2: any = null;
  dropdownStates: boolean[] = [];

  // Propiedades de ordenamiento
  sortColumn: string = '';
  sortDirection: string = 'asc';
  searchTerm: string = '';

  // Propiedades para la tabla y paginación
  empresas: any[] = [];              // Lista original de empresas activas
  filteredTableItems: any[] = [];      // Lista filtrada (resultado de filterData)
  pageSize: number = 5;
  page: number = 1;
  totalItems!: number;

  // Propiedades para el formulario y modal
  editMode: boolean = false;
  empresaselecionada: any;
  formEmpresa!: FormGroup;

  municipios: any[] = []; // Arreglo donde almacenaremos los municipios
  // Para ordenar las columnas de la tabla
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  constructor(
    private empresasService: EmpresasService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private dataService: DataService,
    private router: Router,
    private auth: AuthService
  ) { }

  ngOnInit() {
    this.initializeForm();
    this.listarEmpresas();

  }

  /*** Inicialización del formulario ***/
  initializeForm() {
    this.formEmpresa = this.fb.group({
      nit: [''],
      digito: [''],
      nombre: [''],
      direccion: [''],
      ciudad: [''],
      telefono: ['', [Validators.maxLength(10)]],
      celular: ['', [Validators.maxLength(10)]],
      email: [''],
      observaciones: [''],
      eps: ['true'],
      arl: ['true'],
      afp: ['true'],
      ces: ['true'],
      ccf: ['true'],
      bancos: ['true'],
      transporte: ['true'],
      colegio: ['true'],
      cda: ['true'],
      taller: ['true'],
      eds: ['true'],
      contratista: ['true'],
      proveedor: ['true'],
      aseguradora: ['true'],
      almacen: ['true'],
      serviteca: ['true'],
      entidad: ['true']
    });
  }

  /*** HostListener para cerrar dropdowns al hacer click fuera ***/
  @HostListener('document:click', ['$event'])
  closeDropdown(event: Event) {
    this.openDropdown = null;
    this.openDropdown2 = null;
  }
  stopPropagation(event: Event) {
    event.stopPropagation();
  }

  /*** Métodos de ordenamiento ***/
  onSort({ column, direction }: SortEvent) {
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.sortColumn = column;
    this.sortDirection = direction;
  }

  sortData(column: string) {
    // Actualizar el criterio de ordenamiento:
    // Si ya se está ordenando por la columna indicada, se alterna la dirección;
    // de lo contrario, se establece la columna con orden ascendente.
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    // Ordenar la lista filtrada (filteredTableItems) en función del criterio seleccionado.
    this.filteredTableItems.sort((a, b) => {
      // Convertir los valores a cadena en minúsculas para una comparación consistente.
      const valA = a[column] ? a[column].toString().toLowerCase() : '';
      const valB = b[column] ? b[column].toString().toLowerCase() : '';

      // Si ambos valores son numéricos, se realiza una comparación numérica.
      if (!isNaN(Number(valA)) && !isNaN(Number(valB))) {
        return this.sortDirection === 'asc'
          ? Number(valA) - Number(valB)
          : Number(valB) - Number(valA);
      } else {
        // En caso contrario, se comparan como cadenas de texto.
        return this.sortDirection === 'asc'
          ? valA.localeCompare(valB)
          : valB.localeCompare(valA);
      }
    });
  }


  /*** Método de filtrado ***/
filterData() {
  const searchTextLower = this.searchText.toLowerCase().trim();
  if (!searchTextLower) {
    this.filteredTableItems = [...this.empresas];
  } else {
    this.filteredTableItems = this.empresas.filter(empresa => {
      const nit = empresa.nit ? empresa.nit.toString().toLowerCase() : '';
      const nombre = empresa.nombre ? empresa.nombre.toString().toLowerCase() : '';
      // Buscar en el array de categorias
      const tipo = (empresa.categorias || [])
        .filter(cat => cat && cat.text)       // eliminar nulls y elementos sin text
        .map(cat => cat.text.toLowerCase())  // obtener solo el text en minúsculas
        .join(' ');                          // unir en un solo string para buscar

      return nit.includes(searchTextLower) ||
             nombre.includes(searchTextLower) ||
             tipo.includes(searchTextLower);
    });
  }
  this.page = 1; // Reinicia la paginación al aplicar el filtro
}


  /*** Método para alternar el dropdown de cada fila ***/
  toggleDropdown(index: number) {
    this.dropdownStates = this.dropdownStates.map((state, i) => i === index ? !state : false);
  }

  /*** Métodos para exportar la tabla ***/
  exportToPDF(tableId: string, nameFile: string, titleFile: string) {
    Utils.exportToPDF(tableId, nameFile, titleFile);
  }
  exportarExcel(tableId: string, nameFile: string) {
    Utils.exportVisibleTableToExcel(tableId, nameFile);
  }

  /*** Listado de empresas activas ***/
  listarEmpresas(): void {
    this.empresasService.getEmpresas()
      .pipe(take(1)) // ✅ Se completa automáticamente tras la primera respuesta
      .subscribe({
        next: (empresas) => {
          this.empresas = this.filteredTableItems = empresas;
        },
        error: (err) => {
          console.error('❌ Error al actualizar la tabla de empresas activas:', err);
        }
      });
  }

  /*** Inactivar empresa (acción de eliminar) ***/
  inactivarPersona(nit: string) {
    this.avisoInactivarEmpresas(nit);
  }
  avisoInactivarEmpresas(nit: string | number) {
    Swal.fire({
      title: 'Inactivar',
      text: `¿Deseas inactivar la empresa con nit: ${nit}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, inactivar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.empresasService.inactivarEmpresa(String(nit)).subscribe({
          next: () => {
            Swal.fire('Inactivada!', 'La empresa ha sido inactivada.', 'success');
            this.listarEmpresas(); // Recarga la lista
          },
          error: (error) => {
            console.error('❌ Error al inactivar la Empresa:', error);
            Swal.fire('Error', 'No se pudo inactivar la empresa.', 'error');
          }
        });
      }
    });
  }

  /*** Apertura del modal para agregar/editar empresa ***/
  openModalEmpresas(content: any, empresa?: any) {
    console.log(empresa);
    if (empresa) {
      this.editMode = true;
      this.empresaselecionada = empresa;
      this.formEmpresa.patchValue(empresa);
      this.cargarCiudades();

    } else {
      this.editMode = false;
      this.formEmpresa.reset();
    }
    this.modalService.open(content, {
      size: 'xl',
      backdrop: 'static',
      windowClass: 'custom-modal-full-width'
    });
  }

  /*** Guardar (actualizar) empresa ***/
  guardarEmpresas() {
    if (this.formEmpresa.invalid) {
      Swal.fire({
        icon: 'error',
        title: 'Formulario inválido',
        text: 'Por favor, completa todos los campos correctamente.',
      });
      return;
    }

    const datosEmpresas = this.formEmpresa.value;
    // console.log(datosEmpresas);
    if (this.editMode) {
      // Actualizar empresa existente
      this.empresasService.updateEmpresa(this.empresaselecionada.nit, datosEmpresas).subscribe({
        next: () => {
          Swal.fire({ icon: 'success', title: 'Actualización exitosa', text: 'Empresa actualizada correctamente.' });
          this.cerrarModalYRecargar4();
        },
        error: (err) => {
          this.mostrarError4(err, 'Error al actualizar');
        }
      });
    }
  }

  /*** Cerrar modal y recargar listado ***/
  private cerrarModalYRecargar4() {
    this.modalService.dismissAll();
    this.listarEmpresas();
  }

  /*** Mostrar error en alerta ***/
  private mostrarError4(err: any, titulo: string) {
    Swal.fire({
      icon: 'error',
      title: titulo,
      text: err.error?.message || 'Ocurrió un error inesperado.',
    });
  }

  /*** Cerrar modal manualmente ***/
  cerrarModal(modal: any) {
    if (modal) {
      modal.dismiss();
    } else {
      console.error("⚠️ Error: El modal no está definido.");
    }
  }


  private cargarCiudades(): void {
    forkJoin({
      municipios: this.dataService.getDatos(),

    }).subscribe(
      (resultados) => {
        this.municipios = resultados.municipios;

      },
      (error) => this.handleError(error)
    );

  }
  // Manejo de errores genérico
  private handleError(error: any): void {
    console.error('Error al obtener datos:', error);
  }

  limitarLongitud(event: Event, max: number) {
    const input = event.target as HTMLInputElement;
    if (input.value.length > max) {
      input.value = input.value.slice(0, max);
      // Actualiza el FormControl asociado
      const controlName = input.getAttribute('formControlName');
      if (controlName) {
        this.formEmpresa.get(controlName)?.setValue(input.value);
      }
    }
  }

     cargarDocumentos(nit:string){
   // console.log(nit);
    this.router.navigate(['/digitales-empresa/digitales-empresa',nit]);
  }

  VerDocumentos(nit:string){
   // console.log(nit);
    this.router.navigate(['/file-manager/file-manager',nit]);
  }

}